var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-screen" },
    [
      _c("h2", { staticClass: "mb-4" }, [
        _vm._v("\n    Additional Authentication Required\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    An " +
            _vm._s(_vm.details.AttributeName) +
            " has been sent to " +
            _vm._s(_vm.details.Destination) +
            "\n    Please enter the authorization code from that message and a new\n    password.\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "auth-block has-border" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("label", { attrs: { for: "input-token" } }, [
                    _vm._v("Token")
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { id: "input-token", type: "text" },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          $event.keyCode !== 13
                        ) {
                          return null
                        }
                        return _vm.onSubmitClick($event)
                      }
                    },
                    model: {
                      value: _vm.token,
                      callback: function($$v) {
                        _vm.token = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "token"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.passWordEnabled
                ? _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "new-password" } }, [
                        _vm._v("New Password")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { id: "new-password", type: "password" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              $event.keyCode !== 13
                            ) {
                              return null
                            }
                            return _vm.onSubmitClick($event)
                          }
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "password"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "d-flex justify-content-end flex-no-wrap mt-3" },
                [
                  _vm.error
                    ? _c(
                        "div",
                        {
                          staticClass: "mr-4 alert alert-danger fade show",
                          attrs: { role: "alert" }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.error) + "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2 ml-2 btn btn-secondary",
                      attrs: { variant: "secondary", title: "Cancel" },
                      on: { click: _vm.onCancel }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", title: "Confirm" },
                      on: { click: _vm.onSubmitClick }
                    },
                    [_vm._v("\n          Confirm\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4 d-flex" }, [
        _vm._v(
          "\n    If you have not received the message after five minutes, or if you\n    need immediate assistance, please contact the CDS Global help desk at\n    (515) 246-1001 or via email at cdshelpdesk@cds-global.com\n  "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }